

import {HIDE_CONTEXT_MENU, SET_SELECTED_TEXT, SHOW_CONTEXT_MENU} from "./context-menu-action-creators";

const initialState = {
  isShown: false,
  top: 0,
  left: 0,
  selectedText: ""
};

export default ( state = initialState, action ) => {

  const { top, left, selectedText } = action;

  switch(action.type) {

    case SET_SELECTED_TEXT:
      return {
        ...state,
        selectedText
      };

    case SHOW_CONTEXT_MENU:
      return {
        ...state,
        isShown: true,
        top,
        left: left + 5
      };

    case HIDE_CONTEXT_MENU:
      return {
        ...state,
        isShown: false
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/context-menu/context-menu-reducer.js